"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { jsx } from "react/jsx-runtime";
import WaitingSpinner from "../../components/waiting_spinner";
import React from "react";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import {
  startNewFlowSession,
  verifyNextItemOrGetNext,
  usedNextItem
} from "./flow_mode_service";
import {
  buildFlowModeOnDoneUrl,
  carrierInvoiceWithLoadPath,
  documentBatchWithEmailPath,
  documentGroupPath,
  pathToEmail
} from "./dashboard_paths";
import {
  getReviewPath,
  getNextReviewFromContext
} from "./flow_mode_review_helpers";
import LoadsService from "../loads_service";
import Api from "../../api/api";
import Auth from "../../util/auth";
import { documentReviewServiceStartNext } from "../data/types/Api";
import { DocumentReviewStartNextResponse_NextReviewType } from "../data/types/Pb";
import { replace } from "../app_history";
function invoiceAndLoadStateIds(result) {
  const ids = { loadStateId: null, invoiceId: null };
  const id_context = result == null ? void 0 : result.full_id_context;
  if (id_context == null ? void 0 : id_context.loadStateId) {
    ids.loadStateId = id_context.loadStateId;
    ids.invoiceId = id_context == null ? void 0 : id_context.invoiceId;
  } else if (id_context == null ? void 0 : id_context.ownerCarrierInvoiceLoadStateId) {
    ids.loadStateId = id_context.ownerCarrierInvoiceLoadStateId;
    ids.invoiceId = id_context == null ? void 0 : id_context.ownerCarrierInvoiceId;
  } else if (id_context == null ? void 0 : id_context.conformingSubmissionLoadStateId) {
    ids.loadStateId = id_context.conformingSubmissionLoadStateId;
    ids.invoiceId = id_context == null ? void 0 : id_context.conformingSubmissionCarrierInvoiceId;
  }
  return ids;
}
function buildOptions(result) {
  return __async(this, null, function* () {
    const options = {};
    const ltlReconcileEnabled = Api.Account.currentSettings().ltl_reconcile_enabled;
    const { loadStateId, invoiceId } = invoiceAndLoadStateIds(result);
    if (ltlReconcileEnabled && loadStateId && invoiceId) {
      const loadState = yield LoadsService.getLoad(loadStateId);
      if (loadState) {
        const invoice = loadState.carrier_invoices.find(
          (ci) => ci.id.toString() === invoiceId
        );
        options["invoiceRequiresLtlReconciliation"] = (invoice == null ? void 0 : invoice.requires_ltl_reconciliation) || false;
      }
    }
    return options;
  });
}
function content(state) {
  if (state.loaded) {
    return /* @__PURE__ */ jsx("div", { children: "Redirecting to the next item" });
  }
  return /* @__PURE__ */ jsx("div", { children: "Loading" });
}
function nextUrl(props, state) {
  var _a;
  if (!state.nextItem) {
    return null;
  }
  const urlBuilder = {
    new: () => nextUrlForEmail(state),
    indexing: () => nextUrlForIndexEmail(state),
    "ready-to-audit": () => nextUrlForCarrierInvoice(state),
    replies: () => nextUrlForEmail(state),
    exceptions: () => nextUrlForExceptionedItem(state),
    waiting: () => nextUrlForExceptionedItem(state),
    processed: () => nextUrlForCarrierInvoice(state)
  }[(_a = props.location.query.queue) != null ? _a : ""];
  if (urlBuilder) {
    return urlBuilder();
  } else {
    return null;
  }
}
function nextUrlForEmail(state) {
  const ctx = state.nextItem.full_id_context;
  return pathToEmail({
    emailMessageId: ctx.emailId,
    maybeDocumentBatchId: ctx.batchId,
    maybeEmailType: ctx.emailType,
    hasSubmission: ctx.hasSubmission,
    maybeInvoiceOwnerParams: ctx.ownerFactorInvoiceId ? {
      kind: "factor",
      factorInvoiceId: ctx.ownerFactorInvoiceId
    } : ctx.ownerCarrierInvoiceId ? {
      kind: "carrier",
      loadStateId: ctx.ownerCarrierInvoiceLoadStateId,
      carrierInvoice: {
        invoiceId: ctx.ownerCarrierInvoiceId,
        requiresLtlReconciliation: invoiceRequiresLtlReconciliation(state)
      }
    } : null,
    maybeConformingSubmission: ctx.conformingSubmissionLoadStateId ? {
      loadStateId: ctx.conformingSubmissionLoadStateId,
      carrierInvoice: {
        invoiceId: ctx.conformingSubmissionCarrierInvoiceId,
        requiresLtlReconciliation: invoiceRequiresLtlReconciliation(state)
      }
    } : null
  });
}
function invoiceRequiresLtlReconciliation(state) {
  var _a;
  return ((_a = state.itemOptions) == null ? void 0 : _a.invoiceRequiresLtlReconciliation) || false;
}
function nextUrlForIndexEmail(state) {
  const ctx = state.nextItem.full_id_context;
  return documentBatchWithEmailPath(ctx.batchId, ctx.emailId);
}
function nextUrlForCarrierInvoice(state) {
  const ctx = state.nextItem.full_id_context;
  return carrierInvoiceWithLoadPath(
    ctx.loadStateId,
    ctx.invoiceId,
    invoiceRequiresLtlReconciliation(state)
  );
}
function nextUrlForExceptionedItem(state) {
  const ctx = state.nextItem.full_id_context;
  if (ctx.ownerCarrierInvoiceId) {
    return carrierInvoiceWithLoadPath(
      ctx.ownerCarrierInvoiceLoadStateId,
      ctx.ownerCarrierInvoiceId,
      invoiceRequiresLtlReconciliation(state)
    );
  } else {
    return documentGroupPath(
      ctx.ownerDocumentGroupDocumentBatchId,
      ctx.ownerDocumentGroupId
    );
  }
}
function goToNextBatchOrDashboard(props, state) {
  var _a;
  const nextReview = getNextReviewFromContext((_a = state.nextItem) == null ? void 0 : _a.full_id_context);
  if (nextReview) {
    const reviewPath = getReviewPath(nextReview);
    const onDone = buildFlowModeOnDoneUrl("/app/flow", props.location.search);
    if (reviewPath) {
      usedNextItem();
      console.log("Flow Mode: flowing to document review", {
        reviewPath,
        onDone,
        time: /* @__PURE__ */ new Date()
      });
      replace(reviewPath, { onDone });
      return;
    }
  }
  const nextPath = nextUrl(props, state);
  usedNextItem();
  if (nextPath) {
    const onDone = buildFlowModeOnDoneUrl("/flow", props.location.search);
    const url = nextPath.pathString();
    const query = __spreadProps(__spreadValues({}, nextPath.queryObj()), {
      hasMore: false,
      onDone,
      filters: props.location.query.filters
    });
    console.log("Flow Mode: flowing to ", {
      url,
      query,
      time: /* @__PURE__ */ new Date()
    });
    replace(url, query);
  } else {
    const fallbackOnDone = props.location.query.onDone || "/dashboard";
    console.log(
      "Flow Mode: flowing to dashboard due to not finding next item",
      { onDone: fallbackOnDone, time: /* @__PURE__ */ new Date() }
    );
    ToDashboardWithFilters(props.location, fallbackOnDone);
  }
}
class FlowModeFindNextItemPage extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {});
  }
  componentDidMount() {
    return __async(this, null, function* () {
      if (!this.props.location.query.started) {
        startNewFlowSession();
      }
      const result = yield verifyNextItemOrGetNext(
        this.props.location.query.queue,
        this.props.location.query
      );
      const options = yield buildOptions(result);
      if (!result) {
        if (Auth.getCurrentUser().managed_indexer) {
          try {
            const response = yield documentReviewServiceStartNext({});
            const nextReview = response.nextReview;
            if (nextReview.type !== DocumentReviewStartNextResponse_NextReviewType.NoReview) {
              const nextReviewPath = getReviewPath(nextReview);
              const onDone = "/app/flow" + this.props.location.search;
              replace(nextReviewPath, { onDone });
              return;
            }
          } catch (error) {
            console.error(error);
          }
        }
      }
      this.setState({
        loaded: true,
        nextItem: result,
        itemOptions: options
      });
      goToNextBatchOrDashboard(this.props, this.state);
    });
  }
  render() {
    return /* @__PURE__ */ jsx(
      WaitingSpinner,
      {
        "data-component": "FlowModeFindNextItemPage",
        when: !this.state.loaded,
        children: content(this.state)
      }
    );
  }
}
export default FlowModeFindNextItemPage;
